import { PlatformPrivateServices, createPrivateAPI, LimitedPrivateAPI } from '@wix/editor-platform-private-api';
import { DMEventsBridge, PlatformLifecycleEvent, PlatformPrivateEventEmitter } from '@wix/public-editor-platform-events';
import { PlatformWorkerManager } from '../PlatformWorkerManager';
import { SingleWorkerStrategy } from '../WorkerStrategy';
import { AppRunner } from '../AppRunner';
import { getWorkerUrl } from './getWorkerUrl';
import { PlatformFrameStrategy } from '../PlatformFrameStrategy';
function subscribeOnHostEvents(ps, events) {
  const dmEventsBridge = new DMEventsBridge(events);
  const callback = event => {
    dmEventsBridge.notify(event);
  };
  ps.ds.platform.subscribeOnAppEvents(callback);
  ps.ds.platform.subscribeOnCustomAppEvents(callback);
}
export async function createPlatformWorkerManager(hostType, apis) {
  const platformEvents = new PlatformPrivateEventEmitter();
  const ps = new PlatformPrivateServices(apis.hostAPI, apis.documentServicesAPI, apis.experimentsAPI, platformEvents, apis.editorPointerAPI);
  const workerUrl = await getWorkerUrl();
  const privateAPI = createPrivateAPI(hostType, ps);
  const limitedPrivateAPI = new LimitedPrivateAPI(privateAPI);
  const workerStrategy = new SingleWorkerStrategy(workerUrl, limitedPrivateAPI, platformEvents);
  const frameStrategy = new PlatformFrameStrategy(ps, limitedPrivateAPI, platformEvents);
  const manager = new PlatformWorkerManager(privateAPI, workerStrategy, frameStrategy, platformEvents);
  const runner = new AppRunner(ps, manager);
  await runner.start();
  subscribeOnHostEvents(ps, manager.events);
  manager.events.notify({
    type: PlatformLifecycleEvent.EditorReady,
    payload: {},
    meta: {}
  });
  return manager;
}
//# sourceMappingURL=index.js.map